import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const CachedImage = ({
  src,
  alt = '',
  className = '',
  effect = 'blur',
  placeholder = null,
  threshold = 100,
  wrapperClassName = '',
  ...props
}) => {
  if (!src) {
    return (
      <div className={`bg-secondary flex items-center justify-center ${className}`}>
        <span className="text-muted-foreground text-sm">No image</span>
      </div>
    );
  }

  return (
    <LazyLoadImage
      src={src}
      alt={alt}
      className={className}
      effect={effect}
      threshold={threshold}
      wrapperClassName={wrapperClassName}
      placeholder={
        placeholder || (
          <div className={`bg-secondary animate-pulse ${className}`} />
        )
      }
      {...props}
    />
  );
};

export default CachedImage;
